import type {ImageType} from '@src/common/ui/ApiImage';
import {imagesService} from '@src/features/images/logic/images-service';
import {useQuery} from 'react-query';

export const commonKeys = {
  images: (imageId: string, type?: ImageType) => ['images', imageId, type],
};

export function useImageQuery(imageId: string, type?: ImageType) {
  return useQuery({
    queryKey: commonKeys.images(imageId, type),
    queryFn: async () => await imagesService.getFile(imageId, type),
    staleTime: 1 * 60 * 1000,
    enabled: imageId !== undefined && imageId !== '' && imageId !== null,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
